import React, { useState } from 'react';
import './index.css';

function App() {
  const [formData, setFormData] = useState({
    Name: '',
    Email: '',
    Phone: '',
    Course: '',
    Branch: ''
  });
  const [status, setStatus] = useState('idle'); // idle, loading, error
  const [emailError, setEmailError] = useState('');
  const [consent, setConsent] = useState(false);

  const validateEmailDomain = (email) => {
    const lowerEmail = email.toLowerCase();
    const blockedDomains = ['gimil', 'gmale', 'gamil', 'gmai', 'gmail.co', 'gmal', 'gmaill', 'gmail.con', 'gmeil', 'gmail.com.'];
    const domainPart = lowerEmail.split('@')[1];
    if (!domainPart) return true;
    
    // Check if the domain starts with any blocked variation (excluding the exact 'gmail.com')
    for (let blocked of blockedDomains) {
      if (domainPart.startsWith(blocked) && domainPart !== 'gmail.com') {
        return false;
      }
    }
    return true;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setEmailError('');

    if (!validateEmailDomain(formData.Email)) {
      setEmailError('Please enter a valid email address (e.g., @gmail.com).');
      return;
    }

    setStatus('loading');

    const url = 'https://script.google.com/macros/s/AKfycbwa1m-MbocOvDDZPakcTZ0N0ezyc3hX-dSpbonnwEdxsDjsmZTv0lvLo2Uo_SX0ol7W/exec';
    
    const params = new URLSearchParams();
    for (const key in formData) {
      params.append(key, formData[key]);
    }
    // Send multiple variations of 'Date' just in case there is an accidental space in the Google Sheet header (e.g., 'Date ')
    const dateStr = new Date().toLocaleString('en-IN', { timeZone: 'Asia/Kolkata' });
    params.append('Date', dateStr);
    params.append('Date ', dateStr); // Failsafe for trailing space
    params.append(' Date', dateStr); // Failsafe for leading space
    params.append('date', dateStr);
    params.append('Timestamp', dateStr);

    try {
      await fetch(url, {
        method: 'POST',
        body: params,
        mode: 'no-cors'
      });
      // Redirect to Thank You page
      window.location.href = 'https://atenas.in/thankyou.html';
    } catch (error) {
      setStatus('error');
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === 'Phone') {
      // Strip any alphabetical characters, only allow digits and '+'
      const formattedValue = value.replace(/[^0-9+]/g, '');
      setFormData({ ...formData, [name]: formattedValue });
    } else {
      setFormData({ ...formData, [name]: value });
    }
  };

  return (
    <>
      <div className="topbar">
        <div className="marquee-container">
          <div className="marquee-content">
            <div className="marquee-item">
              Admissions Open for 2026 Batch <span className="sep">•</span> Call / WhatsApp: +91 8422 8499 85 <span className="sep">•</span>
              Admissions Open for 2026 Batch <span className="sep">•</span> Call / WhatsApp: +91 8422 8499 85 <span className="sep">•</span>
              Admissions Open for 2026 Batch <span className="sep">•</span> Call / WhatsApp: +91 8422 8499 85 <span className="sep">•</span>
            </div>
            <div className="marquee-item">
              Admissions Open for 2026 Batch <span className="sep">•</span> Call / WhatsApp: +91 8422 8499 85 <span className="sep">•</span>
              Admissions Open for 2026 Batch <span className="sep">•</span> Call / WhatsApp: +91 8422 8499 85 <span className="sep">•</span>
              Admissions Open for 2026 Batch <span className="sep">•</span> Call / WhatsApp: +91 8422 8499 85 <span className="sep">•</span>
            </div>
          </div>
        </div>
      </div>

      <nav className="nav">
        <div className="container nav-inner">
          <a href="#" className="brand">
            <img src="/weblogo.png" alt="Atenas Fraternity Logo" className="logo-img" />
          </a>
          <div className="nav-links">
            <a href="#course">Course</a>
            <a href="#process">Admissions</a>
            <a href="#deadlines">Deadlines</a>
            <a href="#contact">Contact</a>
          </div>
          <a className="btn btn-primary" href="#apply">Apply Now</a>
        </div>
      </nav>

      <header className="hero">
        <div className="container hero-grid">
          <div>
            <div className="eyebrow">✈ Premium Aviation Career Training</div>
            <h1>Launch Your Career in Aviation</h1>
            <p>Become a confident cabin crew, air hostess or aviation professional with industry-focused training, grooming, communication skills and placement support.</p>
            <div className="hero-actions">
              <a href="#apply" className="btn btn-gold">Apply for 2026 Admissions</a>
              <a href="https://wa.me/918422849985" className="btn btn-outline" target="_blank" rel="noopener noreferrer">WhatsApp Counsellor</a>
            </div>
            <div className="hero-points">
              <div><span style={{color: 'var(--gold)', fontSize: '18px'}}>✔</span> Cabin Crew Training</div>
              <div><span style={{color: 'var(--gold)', fontSize: '18px'}}>✔</span> English & Personality</div>
              <div><span style={{color: 'var(--gold)', fontSize: '18px'}}>✔</span> Interview Preparation</div>
            </div>
          </div>
          <div className="hero-card" id="apply">
            <img src="https://images.unsplash.com/photo-1556388158-158ea5ccacbd?auto=format&fit=crop&w=900&q=85" alt="Aviation training admission enquiry" />
            <div className="form-box">
              <h3>Apply for Admissions</h3>
              <p>Fill the form and our admission counsellor will contact you.</p>
              <form onSubmit={handleSubmit}>
                  <div className="form-row">
                    <input type="text" name="Name" value={formData.Name} onChange={handleChange} placeholder="Full Name" required disabled={status === 'loading'} />
                  </div>
                  <div className="form-row" style={{marginBottom: emailError ? '8px' : '16px'}}>
                    <input type="email" name="Email" value={formData.Email} onChange={handleChange} placeholder="Email Address" required disabled={status === 'loading'} style={{borderColor: emailError ? 'var(--red)' : ''}} />
                  </div>
                  {emailError && <p style={{color: 'var(--red)', fontSize: '13px', margin: '0 0 16px 0', textAlign: 'left'}}>{emailError}</p>}
                  <div className="form-row">
                    <input type="tel" name="Phone" value={formData.Phone} onChange={handleChange} placeholder="Mobile Number" required minLength="10" maxLength="15" disabled={status === 'loading'} />
                  </div>
                  <div className="form-row">
                    <select name="Course" value={formData.Course} onChange={handleChange} required disabled={status === 'loading'}>
                      <option value="" disabled>Select Preferred Course</option>
                      <option>Cabin Crew / Air Hostess Training</option>
                      <option>Aviation & Hospitality</option>
                    </select>
                  </div>
                  <div className="form-row">
                    <select name="Branch" value={formData.Branch} onChange={handleChange} required disabled={status === 'loading'}>
                      <option value="" disabled>Preferred Branch</option>
                      <option>Andheri</option>
                      <option>Vashi</option>
                      <option>Kurla</option>
                      <option>Hyderabad</option>
                    </select>
                  </div>
                  
                  <div style={{display: 'flex', alignItems: 'flex-start', gap: '10px', marginBottom: '16px', fontSize: '13px', color: 'var(--muted)', textAlign: 'left'}}>
                    <input type="checkbox" id="consent" required checked={consent} onChange={(e) => setConsent(e.target.checked)} disabled={status === 'loading'} style={{width: 'auto', marginTop: '4px'}} />
                    <label htmlFor="consent" style={{cursor: 'pointer'}}>I confirm that the details provided are correct and I authorize Atenas to contact me.</label>
                  </div>

                  <button type="submit" className="btn btn-primary" style={{width: '100%'}} disabled={status === 'loading'}>
                    {status === 'loading' ? 'Submitting...' : 'Request Call Back'}
                  </button>
                  {status === 'error' && (
                    <p style={{color: 'var(--red)', marginTop: '12px', fontSize: '14px', textAlign: 'center'}}>Something went wrong. Please try again.</p>
                  )}
                </form>
            </div>
          </div>
        </div>
      </header>

      <section className="trust">
        <div className="container trust-grid">
          <div className="trust-card"><strong>1000+</strong><span>Students Trained</span></div>
          <div className="trust-card"><strong>2026</strong><span>Admissions Open</span></div>
          <div className="trust-card"><strong>100%</strong><span>Placement Support</span></div>
          <div className="trust-card"><strong>3+</strong><span>Campus Locations</span></div>
        </div>
      </section>

      <section className="section" id="course">
        <div className="container">
          <div className="section-head">
            <div className="tag">Why Atenas</div>
            <h2>Training Designed for Aviation Careers</h2>
            <p>Our program focuses on the complete transformation needed to become confident, polished and interview-ready for aviation and hospitality careers.</p>
          </div>
          <div className="cards">
            <div className="card">
              <div className="card-img-wrapper">
                <img src="https://images.unsplash.com/photo-1540962351504-03099e0a754b?auto=format&fit=crop&w=800&q=80" alt="Cabin Crew Training" />
                <div className="icon">✈</div>
              </div>
              <div className="card-content">
                <h3>Cabin Crew Training</h3>
                <p>Learn airline standards, safety basics, passenger handling and professional aviation etiquette.</p>
              </div>
            </div>
            <div className="card">
              <div className="card-img-wrapper">
                <img src="https://images.unsplash.com/photo-1573164713714-d95e436ab8d6?auto=format&fit=crop&w=800&q=80" alt="Communication Skills" />
                <div className="icon">💬</div>
              </div>
              <div className="card-content">
                <h3>Communication Skills</h3>
                <p>Improve English speaking, confidence, voice clarity and customer service communication.</p>
              </div>
            </div>
            <div className="card">
              <div className="card-img-wrapper">
                <img src="https://images.unsplash.com/photo-1487222477894-8943e31ef7b2?auto=format&fit=crop&w=800&q=80" alt="Grooming & Personality" />
                <div className="icon">💎</div>
              </div>
              <div className="card-content">
                <h3>Grooming & Personality</h3>
                <p>Develop premium grooming standards, body language, styling and interview presence.</p>
              </div>
            </div>
            <div className="card">
              <div className="card-img-wrapper">
                <img src="https://images.unsplash.com/photo-1565688534245-05d6b5be184a?auto=format&fit=crop&w=800&q=80" alt="Interview Preparation" />
                <div className="icon">🎤</div>
              </div>
              <div className="card-content">
                <h3>Interview Preparation</h3>
                <p>Get trained for airline interviews, group discussions, HR rounds and resume preparation.</p>
              </div>
            </div>
            <div className="card">
              <div className="card-img-wrapper">
                <img src="https://images.unsplash.com/photo-1436491865332-7a61a109cc05?auto=format&fit=crop&w=800&q=80" alt="Global Career Exposure" />
                <div className="icon">🌍</div>
              </div>
              <div className="card-content">
                <h3>Global Career Exposure</h3>
                <p>Build the skills needed for aviation, hospitality and luxury customer-facing industries.</p>
              </div>
            </div>
            <div className="card">
              <div className="card-img-wrapper">
                <img src="https://images.unsplash.com/photo-1521737604893-d14cc237f11d?auto=format&fit=crop&w=800&q=80" alt="Placement Assistance" />
                <div className="icon">🤝</div>
              </div>
              <div className="card-content">
                <h3>Placement Assistance</h3>
                <p>Receive placement guidance, opportunity updates and career counselling support.</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="section section-alt" id="process">
        <div className="container">
          <div className="section-head">
            <div className="tag">Admission Process</div>
            <h2>Your Application Journey</h2>
            <p>A simple counselling-led process to help you choose the right aviation career path.</p>
          </div>
          <div className="process">
            <div className="step"><h3>Fill Enquiry Form</h3><p>Share your basic details and preferred course.</p></div>
            <div className="step"><h3>Speak to Counsellor</h3><p>Understand eligibility, course details and career scope.</p></div>
            <div className="step"><h3>Career Guidance</h3><p>Attend a counselling session with our admission team.</p></div>
            <div className="step"><h3>Documentation</h3><p>Complete admission formalities and verification.</p></div>
            <div className="step"><h3>Secure Your Seat</h3><p>Confirm your seat for the upcoming batch.</p></div>
          </div>
        </div>
      </section>

      <section className="section" id="deadlines">
        <div className="container deadline-box">
          <div>
            <div className="eyebrow">Admissions Open</div>
            <h2>Application Deadlines for 2026 Batch</h2>
            <p>Seats are limited for cabin crew and aviation training programs. Early applications get priority counselling slots.</p>
            <br />
            <a href="#apply" className="btn btn-gold">Apply Before Seats Fill</a>
          </div>
          <div className="deadline-list">
            <div><span>Applications Open</span><strong>Now</strong></div>
            <div><span>Counselling Rounds</span><strong>Weekly</strong></div>
            <div><span>Batch Intake</span><strong>2026</strong></div>
            <div><span>Seat Availability</span><strong>Limited</strong></div>
          </div>
        </div>
      </section>

      <section className="section section-alt">
        <div className="container split">
          <img src="https://images.unsplash.com/photo-1540962351504-03099e0a754b?auto=format&fit=crop&w=1000&q=85" alt="Aviation career training" />
          <div>
            <div className="tag">Career Outcomes</div>
            <h2>Prepare for Aviation, Hospitality & Luxury Service Careers</h2>
            <p>Our training helps students become polished, confident and ready for customer-facing career opportunities.</p>
            <div className="bullet">
              <div><span className="check">✓</span><span>Airline cabin crew and air hostess interview readiness</span></div>
              <div><span className="check">✓</span><span>Ground staff and airport customer service preparation</span></div>
              <div><span className="check">✓</span><span>Luxury hospitality and guest relations confidence</span></div>
              <div><span className="check">✓</span><span>Personality development for professional growth</span></div>
            </div>
          </div>
        </div>
      </section>

      <section className="section">
        <div className="container">
          <div className="section-head">
            <div className="tag">Student Stories</div>
            <h2>Confidence That Students Can Feel</h2>
          </div>
          <div className="testimonial-grid">
            <div className="quote"><p>“Atenas helped me improve my confidence, grooming and interview preparation.”</p><strong>— Student Testimonial</strong></div>
            <div className="quote"><p>“The counselling and training gave me clarity about my aviation career path.”</p><strong>— Student Testimonial</strong></div>
            <div className="quote"><p>“The personality development sessions made a big difference in my communication.”</p><strong>— Student Testimonial</strong></div>
          </div>
        </div>
      </section>

      <section className="cta" id="contact">
        <div className="container">
          <h2>Your Aviation Career Starts Here</h2>
          <p>Admissions are open for the 2026 batch. Speak to our counsellor and take your first step toward a professional aviation career.</p>
          <div className="hero-actions" style={{justifyContent: 'center', marginBottom: 0}}>
            <a href="#apply" className="btn btn-gold">Apply Now</a>
            <a href="tel:+918422849985" className="btn btn-outline">Call Now</a>
            <a href="https://wa.me/918422849985" className="btn btn-primary" target="_blank" rel="noopener noreferrer">WhatsApp Us</a>
          </div>
        </div>
      </section>

      <footer>
        <div className="container footer-grid">
          <div>
            <div className="brand" style={{marginBottom: '20px'}}>
              <img src="/weblogo.png" alt="Atenas Fraternity Logo" className="logo-img" />
            </div>
            <p>Premium aviation, cabin crew, grooming and personality development training for aspiring aviation professionals.</p>
          </div>
          <div><h4>Courses</h4><a href="#course">Cabin Crew Training</a><a href="#course">Air Hostess Training</a><a href="#course">English & Personality</a></div>
          <div><h4>Branches</h4><p>Andheri</p><p>Vashi</p><p>Hyderabad</p></div>
          <div><h4>Contact</h4><p>+91 8422 8499 85</p><p>www.atenas.in</p><p>Admissions Open 2026</p></div>
        </div>
        <div className="container">
          <div className="footer-bottom">
            <p>&copy; {new Date().getFullYear()} Atenas Aviation Institute. All rights reserved.</p>
          </div>
        </div>
      </footer>

      <a className="floating-wa" href="https://wa.me/918422849985" target="_blank" rel="noopener noreferrer">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-message-circle"><path d="m3 21 1.9-5.7a8.5 8.5 0 1 1 3.8 3.8z"/></svg>
        <span style={{marginLeft: '8px'}}>WhatsApp Admission Counsellor</span>
      </a>

    </>
  );
}

export default App;
